// extracted by css-extract-rspack-plugin
export default {"container":"VHUmC6g8SOIooOwG"};